import styled from 'styled-components';
import { Colors } from '../../utils/colors';
import { Sizes } from '../../utils/sizes';

export const PageContainer = styled.section`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, ${Colors.background} 0%, ${Colors.surface} 100%);
  padding: 48px 16px 64px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 24px 12px 40px;
  }
`;

export const Wrapper = styled.div`
  max-width: 920px;
  margin: 0 auto;
`;

export const Header = styled.header`
  text-align: center;
  margin-bottom: 28px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.12);

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  & img {
    width: 120px;
    height: 120px;
    border-radius: 14px;
    object-fit: cover;
    border: 2.5px solid ${Colors.gold};
    margin-bottom: 16px;
    box-shadow: 0 6px 18px rgba(255, 215, 0, 0.12);

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      width: 90px;
      height: 90px;
      border-width: 2px;
      margin-bottom: 12px;
      box-shadow: 0 3px 12px rgba(255, 215, 0, 0.12);
    }
  }

  & h1 {
    color: ${Colors.yellow};
    font-size: 40px;
    font-weight: 900;
    margin: 0 0 12px 0;
    letter-spacing: -0.5px;
    line-height: 1.2;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 22px;
      margin: 0 0 8px 0;
    }
  }

  & p {
    color: ${Colors.gold};
    font-size: 13px;
    line-height: 1.6;
    max-width: 700px;
    margin: 0 auto;
    font-weight: 500;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 12px;
      line-height: 1.4;
    }
  }
`;

export const ProgressLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 20px 0 24px;
  padding: 14px 18px;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.06) 0%, rgba(184, 134, 11, 0.03) 100%);
  border-radius: 10px;
  border: 1.5px solid rgba(255, 215, 0, 0.2);

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    margin: 12px 0 16px;
    padding: 10px 12px;
    gap: 8px;
  }

  & .left {
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      gap: 6px;
    }
  }

  & .icon {
    font-size: 24px;
    line-height: 1;
    flex-shrink: 0;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 18px;
    }
  }

  & .text {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${Colors.white};
    font-size: 13px;
    font-weight: 600;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 11px;
    }
  }

  & strong {
    color: ${Colors.yellow};
    font-weight: 900;
  }

  & .percentage {
    color: ${Colors.yellow};
    font-weight: 900;
    font-size: 14px;
    min-width: fit-content;
    flex-shrink: 0;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 12px;
      flex-grow: 1;
      text-align: right;
    }
  }

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    font-size: 12px;
    flex-wrap: wrap;
    gap: 10px;
  }
`;

export const CtaBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 20px 0 28px 0;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    margin: 14px 0 18px 0;
    gap: 12px;
  }

  & button,
  & a {
    width: 100%;
    max-width: 520px;
    padding: 16px 32px;
    background: ${Colors.yellow};
    color: ${Colors.dark};
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(255, 215, 0, 0.2);

    &:hover { 
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(255, 215, 0, 0.3);
      background: #FFD700;
    }
    &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 12px;
      padding: 12px 20px;
      max-width: 100%;
      letter-spacing: 0.5px;
    }
  }

  & .price {
    margin-left: 10px;
    font-size: 12px;
    color: ${Colors.dark};
    font-weight: 700;
  }
`;

export const SectionLabel = styled.h2`
  color: ${Colors.white};
  font-size: 16px;
  margin: 0 0 10px 0;
  font-weight: 700;
`;

export const ModuleCard = styled.div`
  background: ${(p) => p.$isPaid ? 'rgba(20, 20, 20, 0.3)' : 'rgba(20, 20, 20, 0.6)'};
  border: 1px solid ${(p) => p.$isPaid ? 'rgba(255, 215, 0, 0.2)' : Colors.gold};
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
`;

export const ModuleHeader = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  color: ${Colors.white};
  padding: 14px 16px;
  opacity: ${(p) => p.$isPaid ? '0.65' : '1'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  text-align: left;

  & .title {
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  & .meta {
    color: ${Colors.gold};
    font-size: 11px;
    margin-top: 2px;
  }

  & .chev {
    color: ${Colors.yellow};
    font-size: 16px;
    transition: transform 0.2s ease;
    transform: ${(p) => (p.$open ? 'rotate(180deg)' : 'rotate(0)')};
  }

  & .locked-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    color: rgba(255, 215, 0, 0.7);
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.2px;
  }

  & .free-lesson-hint {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    margin-left: 8px;
    color: #22c55e;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.2px;
  }
`;

export const LessonList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid rgba(255, 215, 0, 0.15);
`;

export const LessonRow = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.08);
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  opacity: ${(p) => (p.$dimmed ? '0.45' : '1')};
  transition: background 0.15s ease, opacity 0.15s ease;

  &:last-child { border-bottom: none; }
  &:hover {
    background: ${(p) => (p.$clickable ? 'rgba(255, 215, 0, 0.04)' : 'transparent')};
  }

  & .thumb {
    position: relative;
    width: 80px;
    height: 50px;
    border-radius: 4px;
    background: linear-gradient(135deg, rgba(255,215,0,0.12), rgba(184,134,11,0.12));
    color: ${Colors.yellow};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
    overflow: hidden;
  }

  & .thumb img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }

  & .thumb .duration {
    position: relative;
    z-index: 1;
    background: rgba(0, 0, 0, 0.7);
    padding: 2px 5px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: 700;
  }

  & .info {
    flex: 1;
    min-width: 0;
  }

  & .index {
    color: ${Colors.gold};
    font-size: 12px;
    margin-right: 6px;
  }

  & .title {
    color: ${Colors.white};
    font-size: 13px;
    line-height: 1.3;
  }

  & .done {
    color: #22c55e;
    font-size: 16px;
    flex-shrink: 0;
  }

  & .release {
    display: block;
    margin-top: 2px;
    color: ${Colors.gold};
    font-size: 11px;
    font-style: italic;
  }
`;

export const PlayerPage = styled.section`
  width: 100%;
  min-height: 100vh;
  background: ${Colors.dark};
  color: ${Colors.white};
`;

export const PlayerWrapper = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 24px 18px 50px;
`;

export const VideoBox = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  margin: 12px 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 100%;
    height: 100%;
  }

  & .plyr {
    position: relative;
    width: 100%;
    height: 100%;
  }

  & .plyr__video-wrapper {
    width: 100%;
    height: 100%;
  }

  & .plyr__video-embed {
    padding-bottom: 0 !important;
    height: 100%;
  }

  & iframe {
    position: absolute;
    top: -56px;
    left: 0;
    width: 100%;
    height: calc(100% + 112px);
    border: 0;
  }

  & .thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
  }
`;

export const PlayerHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 12px;

  & a {
    color: ${Colors.yellow};
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;

    &:hover { text-decoration: underline; }
  }

  & h1 {
    flex: 1;
    color: ${Colors.white};
    font-size: 16px;
    font-weight: 700;
    margin: 0;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 14px;
    }
  }
`;

export const CompleteButton = styled.button`
  padding: 10px 18px;
  background: ${(p) => (p.$done ? 'transparent' : Colors.yellow)};
  color: ${(p) => (p.$done ? '#22c55e' : Colors.dark)};
  border: 2px solid ${(p) => (p.$done ? '#22c55e' : Colors.yellow)};
  border-radius: 6px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover { transform: translateY(-1px); }
`;

export const StatusBox = styled.div`
  margin: 14px 0;
  padding: 10px 12px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid #3b82f6;
  color: #3b82f6;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
`;

export const PricingCard = styled.div`
  max-width: 520px;
  margin: 8px auto 16px;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.08) 0%, rgba(184, 134, 11, 0.02) 100%);
  border: 1px solid rgba(255, 215, 0, 0.8);
  border-radius: 10px;
  color: ${Colors.white};
  text-align: center;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 10px 12px;
    margin: 6px auto 12px;
  }

  & .badge {
    display: inline-block;
    background: ${Colors.yellow};
    color: ${Colors.dark};
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-bottom: 8px;
    box-shadow: none;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 3px 10px;
      font-size: 7px;
      margin-bottom: 6px;
    }
  }

  & .hoje {
    font-size: 11px;
    color: ${Colors.gold};
    margin-bottom: 2px;
    font-weight: 600;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 10px;
      margin-bottom: 1px;
    }

    & strong {
      color: ${Colors.yellow};
      font-size: 28px;
      font-weight: 900;
      letter-spacing: -0.3px;
      margin-left: 4px;
      display: block;
      margin-top: 0px;
      line-height: 1;

      @media (max-width: ${Sizes.mediaQueryBreak1}) {
        font-size: 22px;
        margin-left: 0;
      }
    }
  }

  & .de {
    font-size: 10px;
    color: ${Colors.textSecondary};
    margin-bottom: 8px;
    font-weight: 500;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 9px;
      margin-bottom: 6px;
    }

    & s {
      margin-left: 4px;
      opacity: 0.6;

      @media (max-width: ${Sizes.mediaQueryBreak1}) {
        margin-left: 2px;
      }
    }
  }

  & .benefits {
    display: flex;
    margin: 10px 0 8px;
    border: 1px solid rgba(255, 215, 0, 0.2);
    border-radius: 8px;
    overflow: hidden;

    & .benefit-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 10px 10px;
      flex: 1;

      &:not(:last-child) {
        border-right: 1px solid rgba(255, 215, 0, 0.2);
      }

      & .benefit-icon {
        font-size: 16px;
        line-height: 1;
        width: 28px;
        height: 28px;
        border: 1px solid rgba(255, 215, 0, 0.35);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      & .benefit-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        text-align: left;
      }

      & .benefit-label {
        font-size: 9px;
        font-weight: 800;
        color: ${Colors.white};
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }

      & .benefit-desc {
        font-size: 8px;
        color: ${Colors.textSecondary};
        line-height: 1.2;
      }
    }
  }

  & .upcoming {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(255, 215, 0, 0.1);

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      margin-top: 6px;
      padding-top: 6px;
    }

    & .upcoming-title {
      font-size: 7px;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      color: ${Colors.yellow};
      font-weight: 900;
      margin-bottom: 6px;

      @media (max-width: ${Sizes.mediaQueryBreak1}) {
        font-size: 6px;
        margin-bottom: 4px;
      }
    }

    & ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: grid;
      grid-template-columns: 1fr;
      gap: 4px;

      @media (max-width: ${Sizes.mediaQueryBreak1}) {
        gap: 3px;
      }
    }

    & li {
      font-size: 10px;
      color: ${Colors.white};
      padding: 4px 8px;
      background: rgba(255, 215, 0, 0.03);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      border: 1px solid rgba(255, 215, 0, 0.08);

      @media (max-width: ${Sizes.mediaQueryBreak1}) {
        font-size: 9px;
        padding: 3px 6px;
        gap: 6px;
      }

      & .date {
        flex: 1;
        color: ${Colors.gold};
        font-weight: 700;
        font-size: 10px;

        @media (max-width: ${Sizes.mediaQueryBreak1}) {
          font-size: 9px;
        }
      }

      & .arrow {
        color: ${Colors.yellow};
        font-weight: bold;
        flex-shrink: 0;
        font-size: 10px;
        opacity: 0.6;

        @media (max-width: ${Sizes.mediaQueryBreak1}) {
          font-size: 9px;
        }
      }

      & .price {
        flex: 1;
        color: ${Colors.yellow};
        font-weight: 900;
        text-align: right;
        font-size: 10px;

        @media (max-width: ${Sizes.mediaQueryBreak1}) {
          font-size: 9px;
        }
      }
    }
  }
`;

export const FreeBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  background: #22c55e;
  color: #0a0a0a;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.4px;
  vertical-align: middle;
`;

export const UnlockBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  margin: 12px 0;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(184, 134, 11, 0.04) 100%);
  border: 1.5px solid ${Colors.yellow};
  border-radius: 10px;

  & .text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  & .text strong {
    color: ${Colors.yellow};
    font-size: 13px;
  }

  & .text span {
    color: ${Colors.gold};
    font-size: 12px;
  }

  & button,
  & a {
    background: ${Colors.yellow};
    color: ${Colors.dark};
    border: none;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 900;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.2s ease;
    white-space: nowrap;

    &:hover {
      transform: translateY(-1px);
    }
  }

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    flex-direction: column;
    align-items: stretch;
    text-align: center;

    & button,
    & a {
      width: 100%;
    }
  }
`;

export const SecurityBadges = styled.div`
  display: flex;
  justify-content: center;
  gap: 28px;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  max-width: 640px;
  margin: 0 auto;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    gap: 16px;
  }

  & .badge {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: ${Colors.gold};
    font-weight: 600;
    flex: 0 1 calc(33.333% - 18px);
    justify-content: center;

    & .icon {
      font-size: 20px;
      line-height: 1;
      flex-shrink: 0;
    }

    & .text {
      display: flex;
      flex-direction: column;
      gap: 2px;

      & .label {
        font-size: 10px;
        font-weight: 900;
        color: ${Colors.white};
        text-transform: uppercase;
        letter-spacing: 0.4px;
        line-height: 1.1;
      }

      & .desc {
        font-size: 9px;
        color: ${Colors.textSecondary};
        font-weight: 500;
      }
    }

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      flex: 0 1 calc(50% - 8px);
    }
  }
`;

